import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, Renderer2, RendererFactory2 } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { TypeMetadataFields } from './metadata.model';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MetadataService {
  private meta!: TypeMetadataFields;
  private renderer: Renderer2;
  private isBrowser: boolean;

  constructor(
    private title: Title,
    private metadata: Meta,
    @Inject(DOCUMENT) private document: Document,
    private rendererFactory: RendererFactory2,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) platformId: string
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.isBrowser = isPlatformBrowser(platformId);
  }

  getFullUrl(): string {
    const path = this.router.url;
    const queryParams = this.activatedRoute.snapshot.queryParams;
    const fragment = this.activatedRoute.snapshot.fragment;

    if (!this.isBrowser) {
      // Rückfall-URL auf dem Server (z. B. nur Pfad ohne Host/Protokoll)
      return path;
    }

    const protocol = window.location.protocol;
    const host = window.location.host;

    let fullUrl = `${protocol}//${host}${path}`;

    if (Object.keys(queryParams).length > 0) {
      const queryString = new URLSearchParams(queryParams).toString();
      fullUrl += `?${queryString}`;
    }

    if (fragment) {
      fullUrl += `#${fragment}`;
    }

    return fullUrl;
  }

  setMetadata(meta?: TypeMetadataFields): void {
    if (!meta) return;
    this.meta = meta;

    if (this.isBrowser) {
      this.setTitle();
      this.setDescription();
      this.setRobots();
    }
  }

  private setTitle(): void {
    this.title.setTitle(this.meta.title);
  }

  private setDescription(): void {
    this.metadata.updateTag({ name: 'description', content: this.meta.description });
  }

  updateCanonicalLink(newCanonicalUrl: string): void {
    if (!this.isBrowser) return;

    const canonicalLink = this.document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      this.renderer.setAttribute(canonicalLink, 'href', newCanonicalUrl);
    }
  }

  private setRobots(): void {
    const follow = this.meta.follow ? 'follow' : 'nofollow';
    const index = this.meta.index ? 'index' : 'noindex';

    this.metadata.updateTag({ name: 'robots', content: `${index}, ${follow}` });
  }
}
